import { loadableUserDetailsAtom } from '@/atoms/queries/user';
import { isHybridNavUser } from '@/utils/user';
import { useAtomValue } from 'jotai';

export const useShouldShowHybridNav = () => {
  const userDetails = useAtomValue(loadableUserDetailsAtom);
  return userDetails.state === 'hasData' && isHybridNavUser(userDetails.data.data);
};
